<div class="mat-elevation-z5 mr-4 mt-16 flex min-h-[300px] flex-col" [class.justify-center]="detailPayneHandler.isWorking">
  @if (!detailPayneHandler.isWorking) {
    @if (detailPayneHandler.topLine) {
      <span class="my-[5px] mr-2.5 self-end text-xs/none uppercase">{{ detailPayneHandler.topLine }}</span>
    }
    <div class="flex min-h-10 w-full flex-row justify-between gap-2.5 bg-[lightgray] px-2.5">
      <h3 class="self-center text-xl font-normal">{{ detailPayneHandler.tableHeading }}</h3>
      @if (detailPayneHandler.shouldShowEmployeeManager) {
        <div class="mt-1.5 flex flex-col justify-start text-end text-sm font-light leading-none">
          <span>Reports To:</span>
          <strong class="font-semibold">
            @if (detailPayneHandler.employeeManagerInfo$ | async; as managerInfo) {
              {{ managerInfo.manager.displayName }}
            } @else {
              <!-- Diameter is the same height in pixels as the "reports to" text above is -->
              <mat-spinner diameter="13" class="!inline-block" />
            }
          </strong>
        </div>
      }
      @if (detailPayneHandler.shouldShowBillCodeMappingButton) {
        <button type="button" class="h-8 cursor-pointer" matTooltip="Map Bill Codes" (click)="handleBillCodeMappingClicked()">
          <mat-icon svgIcon="map-with-pin" [inline]="true" />
        </button>
      }
    </div>
    @for (group of detailPayneHandler.groupedTable; track group) {
      @if (!group.isHidden) {
        @if (group.headerText && group.values.length > 0) {
          <div class="my-2.5 whitespace-pre-line break-words px-[15px] capitalize">
            <!-- plain string headers become bold -->
            @if (isString(group.headerText) && group.type !== 'perDiem') {
              <div [ngClass]="group.cssClass">
                {{ group.headerText }}
              </div>
            }
            <!-- Allows you to make a header with 2 display lines but side-by-side to match table-like without using too much css and instead using exiting grid -->
            @if (group.type === 'perDiem') {
              <!-- Same number of columns as the per diem daily config that will be displayed below this header -->
              <mat-grid-list cols="13" rowHeight="1.5rem" [ngClass]="group.cssClass">
                <mat-grid-tile colspan="7"> <div class="w-full">Per Diem Amount</div></mat-grid-tile>
                <mat-grid-tile colspan="3">
                  <!-- This is centered, but we've gotta push it over a bit to compensate for the dollar sign in the values below this so it appears aligned -->
                  <div class="pr-6 font-bold">{{ group.headerText }}</div>
                </mat-grid-tile>
                <mat-grid-tile colspan="3" /><!--spacer-->
              </mat-grid-list>
            }
            <!-- With an array of string headers we make the first one bold and make the rest look "secondary" -->
            @if (!isString(group.headerText)) {
              @for (header of group.headerText; track header) {
                <div
                  [ngClass]="group.cssClass"
                  [class.font-bold]="$first"
                  [class.text-sm]="!$first"
                  [class.text-gray-500]="!$first"
                >
                  {{ header }}
                </div>
              }
            }
          </div>
        }
        <table-like-layout
          class="px-[15px]"
          configPath="__config"
          [class.mb-4]="group.type === 'perDiem'"
          [appearance]="detailPayneHandler.currentType"
          [config]="group.config"
          [values]="group.values"
          [shouldHideHeaders]="group.shouldHideHeader"
          [shouldHideTotal]="true"
          (iconClicked)="handleIconClicked($event, group)"
          (plainButtonClicked)="handlePlainButtonClicked($event)"
          (valueChanged)="handleValueChange($event)"
        />
      }
    } @empty {
      <p class="flex justify-center text-xl">Add a timesheet to this entity.</p>
    }

    <span class="flex-1"></span>
    @if (detailPayneHandler.canBulkAdd) {
      <div class="flex justify-center pb-5">
        <mat-button-toggle-group multiple hideMultipleSelectionIndicator="true">
          @for (button of dayButtons; track button) {
            <mat-button-toggle
              [value]="button.value"
              [checked]="button.isSelected"
              (change)="handleBulkAddDayButtonChange(button)"
              >{{ button.display }}</mat-button-toggle
            >
          }
        </mat-button-toggle-group>
      </div>
    }
    @if (!detailPayneHandler.isDirectReport) {
      <em class="mb-1 text-center font-normal text-gray-600"> This employee does not report to {{ approvalName }} </em>
    }
    <div class="add-row-buttons flex items-center justify-around self-center">
      <div class="w-[130px]">
        @if (detailPayneHandler.canAddTimesheet) {
          <button class="w-full" mat-raised-button (click)="handleAddTimesheetClicked()">Add Timesheet</button>
        }
      </div>
      <div class="w-[130px]">
        @if (detailPayneHandler.shouldShowNonbill) {
          <button
            class="w-full"
            mat-raised-button
            [disabled]="detailPayneHandler.isAddNonbillableDisabled"
            (click)="handleAddNonbillClicked()"
          >
            Add Nonbillable
          </button>
        }
      </div>
      <div class="w-[130px]">
        @if (detailPayneHandler.shouldShowNonbill) {
          <button
            class="w-full"
            mat-raised-button
            [disabled]="detailPayneHandler.isAddPerDiemDisabled"
            (click)="detailPayneHandler.handleAddPerDiemClicked()"
          >
            Add Per Diem
          </button>
        }
      </div>
      <div class="flex w-[130px] justify-end">
        @if (detailPayneHandler.isSaveBtnVisible) {
          <button
            class="w-full"
            mat-raised-button
            color="primary"
            [disabled]="detailPayneHandler.isSaveBtnDisabled"
            (click)="handleSaveClicked()"
          >
            Save
          </button>
        }
      </div>
    </div>
  } @else {
    <div class="flex h-full items-center justify-center">
      <mat-spinner />
    </div>
  }
</div>
